import React from 'react'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import StyledGridOverlay from 'components/Shared/Grid/NoRows/StyledGridOverlay'

const noRowsOverlay = () => {
  const { t } = useTranslation()

  return (
    <StyledGridOverlay>
      <img src={getAssetURL('/grid/no-rows.svg')} alt="no rows" />
      <Box sx={{ mt: 1 }}>
        <Typography variant="subtitle2" component={'div'}>
          {t('participant.noRecordsFound')}
        </Typography>
      </Box>
    </StyledGridOverlay>
  )
}

export default noRowsOverlay
